import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=1074ce2e&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=ts&"
export * from "./MessageInput.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=1074ce2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074ce2e",
  null
  
)

export default component.exports